import { FC, useMemo, useState } from 'react';
import { LoginLayout } from '@pages/Login/LoginLayout';

import { CurrentEmail } from './CurrentEmail';
import { CheckOTP } from './CheckOTP';
import { Step } from './types';
import { NewPassword } from './NewPassword';
import { Success } from './Success';

export const ForgotPassword: FC = () => {
  const [step, setStep] = useState<Step>({ step: 0 });
  const Component = useMemo(() => {
    switch (step.step) {
      case 0:
        return <CurrentEmail setStep={setStep} initialValues={step.email} />;
      case 1:
        return <CheckOTP setStep={setStep} email={step.email} />;
      case 2:
        return <NewPassword setStep={setStep} email={step.email} otp={step.otp} />;
      case 3:
        return <Success />;
      default:
        return null;
    }
  }, [step]);
  return <LoginLayout>{Component}</LoginLayout>;
};
